import React from 'react';

import { throttle } from '../app/lodash-cut';
import iframeObserver from '../utils/iframe-observer';

export default function withIframeStyle(WrappedComponent, calculateStyle, options = {}) {
  class withIframeStyle extends React.Component {
    state = { style: {} };

    componentDidMount() {
      iframeObserver.addListener(this.iframeUpdateListener);
      if (options.repaintOnInit) {
        if (iframeObserver.hasParentIframe()) {
          const { lastPageInfo } = iframeObserver;
          // TODO dirty hook to manually call pageInfo, better find another way later
          parentIFrame.scrollToOffset(lastPageInfo.scrollLeft, lastPageInfo.scrollTop - lastPageInfo.offsetTop + 1);
        }
      }
    }

    iframeUpdateListener = throttle(info => {
      !!info && this.setState({ style: calculateStyle(info) });
    }, 300);

    componentWillUnmount() {
      iframeObserver.removeListener(this.iframeUpdateListener)
    }

    render() {
      return <WrappedComponent iframeStyle={this.state.style} {...this.props} />;
    }
  }
  withIframeStyle.displayName = `WithIframeStyle(${getDisplayName(WrappedComponent)})`;
  return withIframeStyle;
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
